var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F4FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2428 19.8223C31.403 20.3749 33 22.3343 33 24.6667C33 27.4281 30.7614 29.6667 28 29.6667H18.4167C15.4251 29.6667 13 27.2415 13 24.25C13 21.6981 14.7647 19.5584 17.1403 18.9846C18.27 16.9088 20.4705 15.5 23 15.5C25.8569 15.5 28.294 17.297 29.2428 19.8223ZM19.0774 23.5893C19.4028 23.9147 19.9305 23.9147 20.2559 23.5893L22.1667 21.6785L22.1667 26.3333C22.1667 26.7936 22.5398 27.1667 23 27.1667C23.4602 27.1667 23.8333 26.7936 23.8333 26.3333L23.8333 21.6785L25.7441 23.5893C26.0695 23.9147 26.5972 23.9147 26.9226 23.5893C27.248 23.2638 27.248 22.7362 26.9226 22.4107L23.5893 19.0774C23.2638 18.752 22.7362 18.752 22.4107 19.0774L19.0774 22.4107C18.752 22.7362 18.752 23.2638 19.0774 23.5893Z",
    fill: "#445171"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F8FAFE",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8a93879bf25a63a30de20137bffb0d5a.svg";
export { ForwardRef as ReactComponent };